export const blueGreyMui = {
  /**
   * Preview: ![blueGrey 50](https://mui.com/static/colors-preview/blueGrey-50-24x24.png)
   */
  _50: "#eceff1",
  /**
   * Preview: ![blueGrey 100](https://mui.com/static/colors-preview/blueGrey-100-24x24.png)
   */
  _100: "#cfd8dc",
  /**
   * Preview: ![blueGrey 200](https://mui.com/static/colors-preview/blueGrey-200-24x24.png)
   */
  _200: "#b0bec5",
  /**
   * Preview: ![blueGrey 300](https://mui.com/static/colors-preview/blueGrey-300-24x24.png)
   */
  _300: "#90a4ae",
  /**
   * Preview: ![blueGrey 400](https://mui.com/static/colors-preview/blueGrey-400-24x24.png)
   */
  _400: "#78909c",
  /**
   * Preview: ![blueGrey 500](https://mui.com/static/colors-preview/blueGrey-500-24x24.png)
   */
  _500: "#607d8b",
  /**
   * Preview: ![blueGrey 600](https://mui.com/static/colors-preview/blueGrey-600-24x24.png)
   */
  _600: "#546e7a",
  /**
   * Preview: ![blueGrey 700](https://mui.com/static/colors-preview/blueGrey-700-24x24.png)
   */
  _700: "#455a64",
  /**
   * Preview: ![blueGrey 800](https://mui.com/static/colors-preview/blueGrey-800-24x24.png)
   */
  _800: "#37474f",
  /**
   * Preview: ![blueGrey 900](https://mui.com/static/colors-preview/blueGrey-900-24x24.png)
   */
  _900: "#263238",
  /**
   * Preview: ![blueGrey A100](https://mui.com/static/colors-preview/blueGrey-A100-24x24.png)
   */
  A100: "#cfd8dc",
  /**
   * Preview: ![blueGrey A200](https://mui.com/static/colors-preview/blueGrey-A200-24x24.png)
   */
  A200: "#b0bec5",
  /**
   * Preview: ![blueGrey A400](https://mui.com/static/colors-preview/blueGrey-A400-24x24.png)
   */
  A400: "#78909c",
  /**
   * Preview: ![blueGrey A700](https://mui.com/static/colors-preview/blueGrey-A700-24x24.png)
   */
  A700: "#455a64",
};
